(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["square-icons-with-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var triggers = document.querySelectorAll('.js-fw7k-firstsip-trigger[data-klaviyo-form-id]');
    if (!triggers.length) return;

    function openKlaviyoForm(formId) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }

    function handleClick(e) {
      var formId = this.getAttribute('data-klaviyo-form-id');
      if (!formId) return; // fall through to href
      e.preventDefault();
      openKlaviyoForm(formId);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', handleClick);
      trigger._fw7kFirstsipHandler = handleClick;
    });

    // Cleanup on section unload (Theme Editor)
    document.addEventListener('shopify:section:unload', function (event) {
      var section = event.target;
      var toClean = section.querySelectorAll('.js-fw7k-firstsip-trigger[data-klaviyo-form-id]');
      toClean.forEach(function (t) {
        if (t._fw7kFirstsipHandler) {
          t.removeEventListener('click', t._fw7kFirstsipHandler);
          delete t._fw7kFirstsipHandler;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
